export default __webpack_public_path__ + "static/media/SilentHill.d0e2abf0.mp3";